// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==========================================
   SWITCH LOGS MAIN CONTAINER
   ========================================== */
.sw-main-container {
    width: 100%;
    padding: 20px;
    box-sizing: border-box;
    background-color: #121824;
    color: #e1e7ef;
    min-height: calc(100vh - 80px);
    font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
}

/* ==========================================
   HEADER SECTION & CONTROLS
   ========================================== */
.sw-header-wrapper {
    background-color: #1a2332;
    border-radius: 10px;
    padding: 16px 20px;
    margin-bottom: 20px;
    border: 1px solid #2a364f;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.25);
}

.sw-header-inner {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    gap: 15px;
}

.sw-back-btn {
    background: #22c55e;
    color: white;
    border: none;
    padding: 8px 15px;
    border-radius: 6px;
    font-weight: bold;
    cursor: pointer;
    max-width: 100px;
}

.sw-back-btn:hover {
    background: #324567;
    color: #ffffff;
    border-color: #4c648d;
    transform: translateX(-2px);
}

.sw-page-title {
    margin: 0;
    font-size: 20px;
    font-weight: 700;
    color: #ffffff;
    letter-spacing: 0.5px;
    text-transform: uppercase;
}

.sw-header-controls {
    display: flex;
    align-items: center;
    gap: 12px;
}

/* Dropdown styling */
.sw-dropdown {
    background-color: #0f172a;
    color: #38bdf8;
    border: 1px solid #334155;
    padding: 9px 14px;
    border-radius: 6px;
    font-size: 13px;
    font-weight: 600;
    outline: none;
    cursor: pointer;
    transition: all 0.2s ease;
}

.sw-dropdown:hover, .sw-dropdown:focus {
    border-color: #38bdf8;
    box-shadow: 0 0 0 2px rgba(56, 189, 248, 0.2);
}

.sw-dropdown option {
    background-color: #0f172a;
    color: #ffffff;
}

/* Action Buttons (Refresh & Export) */
.sw-icon-btn {
    width: 38px;
    height: 38px;
    border-radius: 6px;
    border: 1px solid #334155;
    background-color: #0f172a;
    color: #94a3b8;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.2s ease;
    font-size: 14px;
}

.sw-icon-btn.refresh:hover:not(:disabled) {
    background-color: #0369a1;
    color: #ffffff;
    border-color: #0284c7;
}

.sw-icon-btn.export:hover:not(:disabled) {
    background-color: #15803d;
    color: #ffffff;
    border-color: #16a34a;
}

.sw-icon-btn:disabled {
    opacity: 0.4;
    cursor: not-allowed;
}

/* ==========================================
   LOGS DISPLAY TABLE / LIST AREA
   ========================================== */
.sw-log-display-area {
    background-color: #1a2332;
    border-radius: 10px;
    border: 1px solid #2a364f;
    overflow: hidden;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
}

/* Table Header */
.sw-table-header {
    display: grid;
    grid-template-columns: 180px 160px 140px 1fr;
    background-color: #0f172a;
    padding: 12px 20px;
    font-size: 12px;
    font-weight: 700;
    color: #64748b;
    border-bottom: 1px solid #2a364f;
    letter-spacing: 0.5px;
    text-transform: uppercase;
}

.sw-h-col {
    display: flex;
    align-items: center;
}

/* Rows Wrapper */
.sw-rows-wrapper {
    max-height: calc(100vh - 250px);
    overflow-y: auto;
}

/* Scrollbar Customization */
.sw-rows-wrapper::-webkit-scrollbar {
    width: 6px;
}

.sw-rows-wrapper::-webkit-scrollbar-track {
    background: #121824;
}

.sw-rows-wrapper::-webkit-scrollbar-thumb {
    background: #2a364f;
    border-radius: 3px;
}

.sw-rows-wrapper::-webkit-scrollbar-thumb:hover {
    background: #3b4d71;
}

/* Single Log Row */
.sw-log-row {
    display: grid;
    grid-template-columns: 180px 160px 140px 1fr;
    padding: 10px 20px;
    border-bottom: 1px solid #222d42;
    font-size: 13px;
    align-items: center;
    transition: background-color 0.15s ease;
}

.sw-log-row:hover {
    background-color: #222e44;
}

/* Row Columns */
.sw-b-col {
    display: flex;
    flex-direction: column;
    justify-content: center;
}

.sw-b-col.host {
    font-weight: 600;
    color: #f1f5f9;
}

.sw-b-col.time {
    color: #94a3b8;
}

.sw-date-label {
    font-size: 11px;
    color: #64748b;
}

.sw-time-label {
    font-weight: 500;
    font-family: monospace;
}

.sw-b-col.port {
    font-family: monospace;
    font-size: 12px;
    color: #38bdf8;
    background: #0f172a;
    padding: 2px 8px;
    border-radius: 4px;
    width: fit-content;
    border: 1px solid #1e293b;
}

.sw-b-col.msg {
    color: #cbd5e1;
    font-family: 'Consolas', 'Courier New', monospace;
    word-break: break-word;
}

/* ==========================================
   STATUS BASED HIGHLIGHTS
   ========================================== */
.sw-log-row.status-online {
    border-left: 4px solid #10b981;
}

.sw-log-row.status-online .sw-b-col.msg {
    color: #34d399;
}

.sw-log-row.status-offline {
    border-left: 4px solid #ef4444;
    background-color: rgba(239, 68, 68, 0.05);
}

.sw-log-row.status-offline .sw-b-col.msg {
    color: #f87171;
}

.sw-log-row.status-default {
    border-left: 4px solid #64748b;
}

/* ==========================================
   NO DATA & LOAD MORE
   ========================================== */
.sw-no-data {
    padding: 40px;
    text-align: center;
    color: #64748b;
    font-size: 14px;
    font-weight: 500;
}

.sw-load-more-container {
    padding: 15px;
    text-align: center;
    background-color: #0f172a;
    border-top: 1px solid #2a364f;
}

.sw-load-more-btn {
    background-color: #1e293b;
    color: #38bdf8;
    border: 1px solid #334155;
    padding: 8px 24px;
    border-radius: 6px;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s ease;
}

.sw-load-more-btn:hover {
    background-color: #38bdf8;
    color: #0f172a;
    border-color: #38bdf8;
    box-shadow: 0 0 12px rgba(56, 189, 248, 0.3);
}

/* ==========================================
   RESPONSIVE DESIGN FOR MOBILE & TABLETS
   ========================================== */
@media (max-width: 900px) {
    .sw-table-header {
        display: none; /* মোবাইল ডিসপ্লেতে টেবিল হেডার হাইড হবে */
    }

    .sw-log-row {
        grid-template-columns: 1fr;
        gap: 8px;
        padding: 14px;
    }

    .sw-b-col.time {
        flex-direction: row;
        gap: 8px;
        align-items: center;
    }

    .sw-header-inner {
        flex-direction: column;
        align-items: stretch;
    }

    .sw-header-controls {
        justify-content: space-between;
    }

    .sw-dropdown {
        flex: 1 1;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/LogManage/SwitchLog.css"],"names":[],"mappings":"AAAA;;+CAE+C;AAC/C;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,yBAAyB;IACzB,cAAc;IACd,8BAA8B;IAC9B,uFAAuF;AAC3F;;AAEA;;+CAE+C;AAC/C;IACI,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,yBAAyB;IACzB,0CAA0C;AAC9C;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;IACf,SAAS;AACb;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,qBAAqB;IACrB,2BAA2B;AAC/B;;AAEA;IACI,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA,qBAAqB;AACrB;IACI,yBAAyB;IACzB,cAAc;IACd,yBAAyB;IACzB,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,6CAA6C;AACjD;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA,sCAAsC;AACtC;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,yBAAyB;IACzB,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;;+CAE+C;AAC/C;IACI,yBAAyB;IACzB,mBAAmB;IACnB,yBAAyB;IACzB,gBAAgB;IAChB,yCAAyC;AAC7C;;AAEA,iBAAiB;AACjB;IACI,aAAa;IACb,4CAA4C;IAC5C,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,gCAAgC;IAChC,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA,iBAAiB;AACjB;IACI,+BAA+B;IAC/B,gBAAgB;AACpB;;AAEA,4BAA4B;AAC5B;IACI,UAAU;AACd;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA,mBAAmB;AACnB;IACI,aAAa;IACb,4CAA4C;IAC5C,kBAAkB;IAClB,gCAAgC;IAChC,eAAe;IACf,mBAAmB;IACnB,uCAAuC;AAC3C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,gBAAgB;AAChB;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;IACtB,eAAe;IACf,cAAc;IACd,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,iDAAiD;IACjD,sBAAsB;AAC1B;;AAEA;;+CAE+C;AAC/C;IACI,8BAA8B;AAClC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,8BAA8B;IAC9B,yCAAyC;AAC7C;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;;+CAE+C;AAC/C;IACI,aAAa;IACb,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,yBAAyB;IACzB,6BAA6B;AACjC;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,yBAAyB;IACzB,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,qBAAqB;IACrB,4CAA4C;AAChD;;AAEA;;+CAE+C;AAC/C;IACI;QACI,aAAa,EAAE,0CAA0C;IAC7D;;IAEA;QACI,0BAA0B;QAC1B,QAAQ;QACR,aAAa;IACjB;;IAEA;QACI,mBAAmB;QACnB,QAAQ;QACR,mBAAmB;IACvB;;IAEA;QACI,sBAAsB;QACtB,oBAAoB;IACxB;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,SAAO;IACX;AACJ","sourcesContent":["/* ==========================================\n   SWITCH LOGS MAIN CONTAINER\n   ========================================== */\n.sw-main-container {\n    width: 100%;\n    padding: 20px;\n    box-sizing: border-box;\n    background-color: #121824;\n    color: #e1e7ef;\n    min-height: calc(100vh - 80px);\n    font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n}\n\n/* ==========================================\n   HEADER SECTION & CONTROLS\n   ========================================== */\n.sw-header-wrapper {\n    background-color: #1a2332;\n    border-radius: 10px;\n    padding: 16px 20px;\n    margin-bottom: 20px;\n    border: 1px solid #2a364f;\n    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.25);\n}\n\n.sw-header-inner {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    flex-wrap: wrap;\n    gap: 15px;\n}\n\n.sw-back-btn {\n    background: #22c55e;\n    color: white;\n    border: none;\n    padding: 8px 15px;\n    border-radius: 6px;\n    font-weight: bold;\n    cursor: pointer;\n    max-width: 100px;\n}\n\n.sw-back-btn:hover {\n    background: #324567;\n    color: #ffffff;\n    border-color: #4c648d;\n    transform: translateX(-2px);\n}\n\n.sw-page-title {\n    margin: 0;\n    font-size: 20px;\n    font-weight: 700;\n    color: #ffffff;\n    letter-spacing: 0.5px;\n    text-transform: uppercase;\n}\n\n.sw-header-controls {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n}\n\n/* Dropdown styling */\n.sw-dropdown {\n    background-color: #0f172a;\n    color: #38bdf8;\n    border: 1px solid #334155;\n    padding: 9px 14px;\n    border-radius: 6px;\n    font-size: 13px;\n    font-weight: 600;\n    outline: none;\n    cursor: pointer;\n    transition: all 0.2s ease;\n}\n\n.sw-dropdown:hover, .sw-dropdown:focus {\n    border-color: #38bdf8;\n    box-shadow: 0 0 0 2px rgba(56, 189, 248, 0.2);\n}\n\n.sw-dropdown option {\n    background-color: #0f172a;\n    color: #ffffff;\n}\n\n/* Action Buttons (Refresh & Export) */\n.sw-icon-btn {\n    width: 38px;\n    height: 38px;\n    border-radius: 6px;\n    border: 1px solid #334155;\n    background-color: #0f172a;\n    color: #94a3b8;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    font-size: 14px;\n}\n\n.sw-icon-btn.refresh:hover:not(:disabled) {\n    background-color: #0369a1;\n    color: #ffffff;\n    border-color: #0284c7;\n}\n\n.sw-icon-btn.export:hover:not(:disabled) {\n    background-color: #15803d;\n    color: #ffffff;\n    border-color: #16a34a;\n}\n\n.sw-icon-btn:disabled {\n    opacity: 0.4;\n    cursor: not-allowed;\n}\n\n/* ==========================================\n   LOGS DISPLAY TABLE / LIST AREA\n   ========================================== */\n.sw-log-display-area {\n    background-color: #1a2332;\n    border-radius: 10px;\n    border: 1px solid #2a364f;\n    overflow: hidden;\n    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);\n}\n\n/* Table Header */\n.sw-table-header {\n    display: grid;\n    grid-template-columns: 180px 160px 140px 1fr;\n    background-color: #0f172a;\n    padding: 12px 20px;\n    font-size: 12px;\n    font-weight: 700;\n    color: #64748b;\n    border-bottom: 1px solid #2a364f;\n    letter-spacing: 0.5px;\n    text-transform: uppercase;\n}\n\n.sw-h-col {\n    display: flex;\n    align-items: center;\n}\n\n/* Rows Wrapper */\n.sw-rows-wrapper {\n    max-height: calc(100vh - 250px);\n    overflow-y: auto;\n}\n\n/* Scrollbar Customization */\n.sw-rows-wrapper::-webkit-scrollbar {\n    width: 6px;\n}\n\n.sw-rows-wrapper::-webkit-scrollbar-track {\n    background: #121824;\n}\n\n.sw-rows-wrapper::-webkit-scrollbar-thumb {\n    background: #2a364f;\n    border-radius: 3px;\n}\n\n.sw-rows-wrapper::-webkit-scrollbar-thumb:hover {\n    background: #3b4d71;\n}\n\n/* Single Log Row */\n.sw-log-row {\n    display: grid;\n    grid-template-columns: 180px 160px 140px 1fr;\n    padding: 10px 20px;\n    border-bottom: 1px solid #222d42;\n    font-size: 13px;\n    align-items: center;\n    transition: background-color 0.15s ease;\n}\n\n.sw-log-row:hover {\n    background-color: #222e44;\n}\n\n/* Row Columns */\n.sw-b-col {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n}\n\n.sw-b-col.host {\n    font-weight: 600;\n    color: #f1f5f9;\n}\n\n.sw-b-col.time {\n    color: #94a3b8;\n}\n\n.sw-date-label {\n    font-size: 11px;\n    color: #64748b;\n}\n\n.sw-time-label {\n    font-weight: 500;\n    font-family: monospace;\n}\n\n.sw-b-col.port {\n    font-family: monospace;\n    font-size: 12px;\n    color: #38bdf8;\n    background: #0f172a;\n    padding: 2px 8px;\n    border-radius: 4px;\n    width: fit-content;\n    border: 1px solid #1e293b;\n}\n\n.sw-b-col.msg {\n    color: #cbd5e1;\n    font-family: 'Consolas', 'Courier New', monospace;\n    word-break: break-word;\n}\n\n/* ==========================================\n   STATUS BASED HIGHLIGHTS\n   ========================================== */\n.sw-log-row.status-online {\n    border-left: 4px solid #10b981;\n}\n\n.sw-log-row.status-online .sw-b-col.msg {\n    color: #34d399;\n}\n\n.sw-log-row.status-offline {\n    border-left: 4px solid #ef4444;\n    background-color: rgba(239, 68, 68, 0.05);\n}\n\n.sw-log-row.status-offline .sw-b-col.msg {\n    color: #f87171;\n}\n\n.sw-log-row.status-default {\n    border-left: 4px solid #64748b;\n}\n\n/* ==========================================\n   NO DATA & LOAD MORE\n   ========================================== */\n.sw-no-data {\n    padding: 40px;\n    text-align: center;\n    color: #64748b;\n    font-size: 14px;\n    font-weight: 500;\n}\n\n.sw-load-more-container {\n    padding: 15px;\n    text-align: center;\n    background-color: #0f172a;\n    border-top: 1px solid #2a364f;\n}\n\n.sw-load-more-btn {\n    background-color: #1e293b;\n    color: #38bdf8;\n    border: 1px solid #334155;\n    padding: 8px 24px;\n    border-radius: 6px;\n    font-size: 13px;\n    font-weight: 600;\n    cursor: pointer;\n    transition: all 0.2s ease;\n}\n\n.sw-load-more-btn:hover {\n    background-color: #38bdf8;\n    color: #0f172a;\n    border-color: #38bdf8;\n    box-shadow: 0 0 12px rgba(56, 189, 248, 0.3);\n}\n\n/* ==========================================\n   RESPONSIVE DESIGN FOR MOBILE & TABLETS\n   ========================================== */\n@media (max-width: 900px) {\n    .sw-table-header {\n        display: none; /* মোবাইল ডিসপ্লেতে টেবিল হেডার হাইড হবে */\n    }\n\n    .sw-log-row {\n        grid-template-columns: 1fr;\n        gap: 8px;\n        padding: 14px;\n    }\n\n    .sw-b-col.time {\n        flex-direction: row;\n        gap: 8px;\n        align-items: center;\n    }\n\n    .sw-header-inner {\n        flex-direction: column;\n        align-items: stretch;\n    }\n\n    .sw-header-controls {\n        justify-content: space-between;\n    }\n\n    .sw-dropdown {\n        flex: 1;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
